import React from 'react';
import SelectEntityFactory from '../Common/SelectEntityFactory';
import OrganisationActions from '../../actions/OrganisationActionCreator';

export default SelectEntityFactory(OrganisationActions.search);
